module.exports = __webpack_public_path__ + "media/images/client/favicons/android-chrome-192x192-82bae81cfb0cdf85a3d3f9228168128c.png";